/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  dublicateAlert,
  errorAlert,
  messageAlert,
  successAlert,
} from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import {
  Box,
  Checkbox,
  colors,
  fade,
  FormControlLabel,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import { CalenderLocal, TextFieldLocal } from '../components';
import { weekdaysNNo } from '../constants/datatypes';
import _ from 'lodash';
import { getPopupTitle } from '../constants/menu';
import { useCustomers, useProducts, useServices, useTemplate } from '../hooks';
import PopupCustomer from './PopupCustomer';
import PopupDeprtment from './PopupDeprtment';
import PopupEmployee from './PopupEmployee';
import PopupResourses from './PopupResourses';
import useDepartments from '../hooks/useDepartments';
import useEmployees from '../hooks/useEmployees';
import useResourses from '../hooks/useResourses';
import ServiceItemForm from '../Shared/ServiceItemForm';
import ItemsContractTable from '../Shared/ItemsContractTable';
import { invoiceClasses } from '../themes';
import { getDateDayName, getDefaultTemplate, tafkeet } from '../common/helpers';
import { useReactToPrint } from 'react-to-print';
import { useLazyQuery } from '@apollo/client';
import { getOperationItems } from '../graphql';
import getGereralCalculation from '../graphql/query/getGereralCalculation';
import usePrintTemplates from '../hooks/usePrintTemplates';
import PrintDownload from '../Shared/PrintDownload';
import ExtraList from '../Shared/ExtraList';
import useRetypes from '../hooks/useRetypes';
import { tasktypes } from '../constants/rrule';
import { moneyFormat } from '../Shared/colorFormat';
import { rid } from '../Sections/generator/print/renders';
import { ImageView } from '../components/viewer';
import { UploadPhotos } from '../common/UploadPhotos';
import { uploadMultiPhotoOnline } from '../common/AvatarUpload';
import useCollectiveitems from '../hooks/useCollectiveitems';
import useRentitems from '../hooks/useRentitems';
import { userroles } from '../common';

const msg =
  'نود أن نشكركم على ثقتكم بنا واختياركم لخدماتنا. نسعد بالعمل على تحقيق رؤيتكم في هذا اليوم المميز. إذا كان لديكم أي استفسار أو طلبات إضافية، لا تترددوا في  لتواصل معنا.مع خالص التمنيات بأجمل الأوقات.';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const getParagraphs = ({ items, extra, isRTL }: any) => {
  if (items?.length === 0 && extra?.length === 0) return [];
  const list =
    !items || items?.length === 0
      ? []
      : _(items)
          .groupBy(isRTL ? 'categoryNameAr' : 'categoryNameAr')
          .map((array, key) => ({
            group: key,
            qty: array.length,
            subitems: array,
          }))
          .value();

  const ronelist =
    !items || items?.length === 0
      ? []
      : list.map((item: any) => {
          const subitems = item?.subitems?.map((sitem: any) => {
            return {
              id: sitem._id,
              title: isRTL ? sitem.nameAr : sitem.name,
              desc: sitem.note,
            };
          });
          return {
            id: rid(),
            title: item?.group,
            subitems,
          };
        });
  return [...ronelist, ...extra];
};

const PopupTaskFree = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  employees,
  resourses,
  departments,
  customers,
  theme,
  value = null,
  name = null,
  company,
  tasks,
}: any) => {
  const classes = invoiceClasses();

  const [saving, setSaving] = useState(false);
  const [memitem, setMemitem] = useState(null);
  const [tasktitle, setTasktitle]: any = useState(null);
  const [start, setStart]: any = useState(null);
  const [end, setEnd]: any = useState(null);
  const [printdate, setPrintdate]: any = useState(null);
  const [closedate, setClosedate]: any = useState(null);
  const [printtitle, setPrinttitle]: any = useState(null);
  const [desc, setDesc]: any = useState(null);
  const [address, setAddress]: any = useState(null);
  const [extra, setExtra]: any = useState([]);
  const [deposit, setDeposit]: any = useState(null);
  const [rtypevalue, setRtypevalue] = useState<any>(null);
  const [typefree, setTypefree] = useState<any>(null); // يومي اسبوعي شهري سنوي
  const [type, setType] = useState<any>(''); // payment type
  const [taskvalue, setTaskvalue] = useState<any>(null);
  const [smsmsg, setSmsmsg]: any = useState(msg);
  const [sendSms, setSendSms]: any = useState(false);

  const [departvalue, setDepartvalue] = useState<any>(
    name === 'departmentId' ? value : null,
  );
  const [departError, setDepartError] = useState<any>(false);
  const departRef: any = React.useRef();

  const [emplvalue, setEmplvalue] = useState<any>(
    name === 'employeeId' ? value : null,
  );
  const [emplError, setEmplError] = useState<any>(false);
  const emplRef: any = React.useRef();
  const [resovalue, setResovalue] = useState<any>(
    name === 'resourseId' ? value : null,
  );
  const [resoError, setResoError] = useState<any>(false);
  const resoRef: any = React.useRef();

  const [custvalue, setCustvalue] = useState<any>(
    name === 'customerId' ? value : null,
  );
  const [custError, setCustError] = useState<any>(false);
  const custRef: any = React.useRef();

  const [newtext, setNewtext] = useState('');
  const [openCust, setOpenCust] = useState(false);
  const [openDep, setOpenDep] = useState(false);
  const [openEmp, setOpenEmp] = useState(false);
  const [openRes, setOpenRes] = useState(false);

  const [itemsList, setItemsList] = useState<any>([]);

  const [total, setTotal] = useState<any>(0);
  const [calcs, setCalcs] = useState<any>(null);

  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const [urls, setUrls] = useState([]);
  const [photosimages, setPhotosimages] = useState([]);
  const [photosurls, setPhotosurls] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [warningDialogOpen, setWarningDialogOpen] = useState(false);
  const [warningMessages, setWarningMessages] = useState<string[]>([]);

  const { addCustomer, editCustomer } = useCustomers();
  const { addDepartment, editDepartment } = useDepartments();
  const { addEmployee, editEmployee } = useEmployees();
  const { addResourse, editResourse } = useResourses();
  const { tempwords, tempoptions, taskoptions } = useTemplate();
  const { products } = useProducts();
  const { services } = useServices();
  const { printtemplates } = usePrintTemplates();
  const { retypes } = useRetypes();
  const { rentitems } = useRentitems();
  const { collectiveitems } = useCollectiveitems();

  const { register, reset } = useForm({});
  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);
  const [getItems, itemsData]: any = useLazyQuery(getOperationItems, {
    fetchPolicy: 'cache-and-network',
  });
  const [loadCalcs, calcsData]: any = useLazyQuery(getGereralCalculation, {
    fetchPolicy: 'cache-and-network',
  });
  useEffect(() => {
    if (row) {
      setMemitem(row);
    }
  }, [row, open]);

  useEffect(() => {
    let locals = [];
    let online = [];
    if (photosimages && photosimages.length > 0) {
      for (const img of photosimages) {
        const localimage = URL.createObjectURL(img);
        locals.push(localimage);
      }
    } else {
      locals = [];
    }
    if (photosurls && photosurls.length > 0) {
      online = photosurls;
    } else {
      online = [];
    }
    setUrls([...online, ...locals]);
  }, [photosimages, photosurls]);

  const addToPhotos = (photos: any) => {
    const lphotos = [...photosimages];
    const li = photosimages.length;
    const oi = photosurls.length;
    const n = 10 - (oi + li);
    if (n < 1 || !photos || photos.length === 0) {
      return;
    } else {
      const newphotos = [...lphotos, ...photos];
      const fnewphotos = newphotos.slice(0, n);
      setPhotosimages(fnewphotos);
    }
  };
  const removePhoto = (src: any, index: any) => {
    if (src.startsWith('http')) {
      const newphotosurls = [...photosurls];
      const newlist = newphotosurls.filter((nu: any) => nu !== src);
      setPhotosurls(newlist);
    } else {
      const newList = [...photosimages];
      const newindex = index - photosurls.length;
      newList.splice(newindex, 1);
      setPhotosimages(newList);
    }
  };

  const onChangeDeposit = (e: any) => {
    const value = Number(e.target.value);
    setDeposit(value);
  };
  const onChangeType = (e: any) => {
    const value = e.target.value;
    setType(value);
  };

  useEffect(() => {
    if (memitem && memitem._id) {
      const items = itemsData?.data?.['getOperationItems']?.data || [];
      const calcs = calcsData?.data?.['getGereralCalculation']?.data;
      if (calcs) {
        const data = JSON.parse(calcs);
        setCalcs(data);
      }
      if (items && items.length > 0) {
        const ids = items.map((it: any) => it.itemId);
        const servlist = [
          ...services,
          ...products,
          ...rentitems,
          ...collectiveitems,
        ].filter((ser: any) => ids.includes(ser._id));
        const itemsWqtyprice = items.map((item: any, index: any) => {
          const {
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            note,
          } = item;
          const serv = servlist.filter((se: any) => se._id === item.itemId)[0];
          return {
            ...serv,
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            index,
            itemprice: item.itemPrice,
            itemqty: item.qty,
            itemtotal: item.total,
            note,
          };
        });
        itemsWqtyprice.sort((a: any, b: any) =>
          a.indx > b.indx ? 1 : b.indx > a.indx ? -1 : 0,
        );
        setItemsList(itemsWqtyprice);
      } else {
        setItemsList([]);
      }
    }
  }, [itemsData, memitem]);

  useEffect(() => {
    const itemsTotal = _.sumBy(itemsList, 'itemtotal');
    setTotal(itemsTotal);
  }, [itemsList]);

  const addItemToList = (item: any) => {
    let newArray: any;
    if (item?.itemType === 5) {
      const sitems = JSON.parse(item.subitems);
      const subitems = sitems?.map((si: any) => {
        return {
          ...si,
          parentitem: item._id,
        };
      });
      newArray = [...itemsList, { ...item, userId: user._id }, ...subitems];
    } else {
      newArray = [...itemsList, { ...item, userId: user._id }];
    }
    const listwithindex = indexTheList(newArray);
    setItemsList(listwithindex);
  };
  const editItemInList = (item: any) => {
    const newArray = itemsList.map((it: any) => {
      if (it._id === item._id && it?.index === item?.index) {
        return item;
      } else {
        return it;
      }
    });
    const listwithindex = indexTheList(newArray);
    setItemsList(listwithindex);
  };

  const removeItemFromList = (index: any) => {
    const newList = [...itemsList];
    newList.splice(index, 1);
    const listwithindex = indexTheList(newList);
    setItemsList(listwithindex);
  };

  const template = getDefaultTemplate(printtemplates, 'contract');

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Contract #${memitem?.docNo}`,
    removeAfterPrint: true,
  });

  const balance = memitem?.amount - calcs?.totalpaid;
  const paragraphs = getParagraphs({ items: itemsList, extra, isRTL });
  const printData = {
    no: memitem?.docNo,
    amount: memitem?.amount,
    start,
    end,
    resovalue,
    custvalue,
    resourseName: isRTL ? resovalue?.nameAr : resovalue?.name,
    resoursePlate: resovalue?.plate,
    resourseInsurance: resovalue?.insurance,
    customerName: isRTL ? custvalue?.nameAr : custvalue?.name,
    customerArea: custvalue?.area,
    customerAddress: custvalue?.address,
    customerPhone: custvalue?.phone,
    customerDriver: custvalue?.driver,
    customerLicenseNo: custvalue?.licenseNo,
    customerLicenseDate: custvalue?.licenseDate,
    customerNational: custvalue?.national,
    customerNationalNo: custvalue?.nationalNo,
    customerNationalDate: custvalue?.nationalDate,
    totalpaid: calcs?.totalpaid,
    daily:
      memitem?.dayCost > 0
        ? memitem?.dayCost
        : memitem?.amount / memitem?.evQty || 0,
    price: memitem?.amount,
    isRTL,
    tafkeet: tafkeet(memitem?.amount, isRTL),
    balance,
    type,
    paragraphs,
    address,
    desc,
    title: memitem?.title,
    printdate,
    closedate,
    printtitle,
    companyname: company?.name,
    companytel1: company?.tel1,
    companyfax: company?.fax,
    companyaddress: company?.address,
    printDay: getDateDayName(printdate, isRTL),
    startDay: getDateDayName(start, isRTL),
    location: isRTL ? resovalue?.name : resovalue?.nameAr,
    packName: isRTL ? itemsList?.[0]?.nameAr : itemsList?.[0]?.name, // todo resourse address
    signatureName: user?.name || user?.signatureName,
    signatureImage: user?.signatureImage,
    employeeSignatureImage: emplvalue?.signatureImage,
  };

  const openDepartment = () => {
    setOpenDep(true);
  };
  const onCloseDepartment = () => {
    setOpenDep(false);
    setNewtext('');
  };
  const openEmployee = () => {
    setOpenEmp(true);
  };
  const onCloseEmploee = () => {
    setOpenEmp(false);
    setNewtext('');
  };
  const openResourse = () => {
    setOpenRes(true);
  };
  const onCloseResourse = () => {
    setOpenRes(false);
    setNewtext('');
  };
  const openCustomer = () => {
    setOpenCust(true);
  };
  const onCloseCustomer = () => {
    setOpenCust(false);
    setNewtext('');
  };

  const onNewCustChange = (nextValue: any) => {
    setCustvalue(nextValue);
  };
  const onNewDepartChange = (nextValue: any) => {
    setDepartvalue(nextValue);
  };
  const onNewEmplChange = (nextValue: any) => {
    setEmplvalue(nextValue);
  };
  const onNewResoChange = (nextValue: any) => {
    setResovalue(nextValue);
  };

  const isemployee = user?.isEmployee && user?.employeeId;

  useEffect(() => {
    if (isemployee) {
      const emp = employees.filter(
        (em: any) => em._id === user.employeeId,
      )?.[0];
      setEmplvalue(emp);
    }
  }, [user, employees]);

  useEffect(() => {
    if (isNew) {
      const start = new Date();
      const end = new Date();
      start.setHours(8, 0, 0, 0);
      end.setHours(20, 0, 0, 0);
      setStart(start);
      setEnd(end);
      setPrintdate(start);
      if (taskoptions?.printtitle) {
        setPrinttitle('عنوان العقد للطباعة');
      }
    }
  }, [open]);

  useEffect(() => {
    if (memitem && memitem._id) {
      getItems({ variables: { opId: memitem._id } });
      loadCalcs({ variables: { contractId: memitem._id } });
      const depId = memitem.departmentId;
      const empId = memitem.employeeId;
      const custId = memitem.customerId;
      const resId = memitem.resourseId;
      const start = memitem?.start ? new Date(memitem?.start) : null;
      const end = memitem?.end ? new Date(memitem?.end) : null;
      const printd = memitem?.printdate ? new Date(memitem?.printdate) : null;
      setDeposit(memitem?.deposit);

      if (memitem?.parent) {
        const tsk = tasks.filter((ts: any) => ts._id === memitem?.parent)[0];
        setTaskvalue(tsk);
      }

      if (!isNew) {
        setStart(start);
        setEnd(end);
        setPrintdate(printd);
      }
      if (row?.closedate) {
        const cd = new Date(row?.closedate);
        setClosedate(cd);
      }
      setPrinttitle(memitem?.printtitle);
      setTasktitle(memitem?.title);

      if (depId) {
        const depart = departments.filter((dep: any) => dep._id === depId)[0];
        setDepartvalue(depart);
      }
      if (empId) {
        const empl = employees.filter((emp: any) => emp._id === empId)[0];
        setEmplvalue(empl);
      }
      if (resId) {
        const empl = resourses.filter((emp: any) => emp._id === resId)[0];
        setResovalue(empl);
      }
      if (custId) {
        const cust = customers.filter((cu: any) => cu._id === custId)[0];
        setCustvalue(cust);
      }
      if (memitem?.typefree) {
        const tt = tasktypes.filter(
          (cu: any) => cu.id === memitem?.typefree,
        )[0];
        setTypefree(tt);
      }
      setDesc(memitem?.desc);
      setType(memitem?.type);
      setAddress(memitem?.address);
      if (memitem?.extra) {
        const ext = JSON.parse(memitem?.extra);
        setExtra(ext);
      }
      if (memitem?.retypeId) {
        const depart = retypes.filter(
          (dep: any) => dep._id === memitem.retypeId,
        )[0];
        setRtypevalue(depart);
      }
      if (memitem.photos) {
        const phs = JSON.parse(memitem.photos);
        if (phs && phs.length > 0) {
          setPhotosurls(phs);
        }
      }
      setDiscount(memitem?.discount);
    }
  }, [memitem]);
  const customer = custvalue
    ? {
        customerId: custvalue._id,
        customerName: custvalue.name,
        customerNameAr: custvalue.nameAr,
        customerPhone: custvalue.phone,
      }
    : {
        customerId: undefined,
        customerName: undefined,
        customerNameAr: undefined,
        customerPhone: undefined,
      };

  const department = departvalue
    ? {
        departmentId: departvalue._id,
        departmentName: departvalue.name,
        departmentNameAr: departvalue.nameAr,
        departmentColor: departvalue.color,
      }
    : {
        departmentId: undefined,
        departmentName: undefined,
        departmentNameAr: undefined,
        departmentColor: undefined,
      };
  const employee = emplvalue
    ? {
        employeeId: emplvalue._id,
        employeeName: emplvalue.name,
        employeeNameAr: emplvalue.nameAr,
        employeeColor: emplvalue.color,
        employeePhone: emplvalue.phone,
      }
    : {
        employeeId: undefined,
        employeeName: undefined,
        employeeNameAr: undefined,
        employeeColor: undefined,
        employeePhone: undefined,
      };
  const resourse = resovalue
    ? {
        resourseId: resovalue._id,
        resourseName: resovalue.name,
        resourseNameAr: resovalue.nameAr,
        resourseColor: resovalue.color,
      }
    : {
        resourseId: undefined,
        resourseName: undefined,
        resourseNameAr: undefined,
        resourseColor: undefined,
      };
  const retype = rtypevalue
    ? {
        retypeId: rtypevalue._id,
        retypeName: rtypevalue.name,
        retypeNameAr: rtypevalue.nameAr,
        retypeColor: rtypevalue.color,
      }
    : {
        retypeId: undefined,
        retypeName: undefined,
        retypeNameAr: undefined,
        retypeColor: undefined,
      };

  const resetAllForms = () => {
    setStart(null);
    setPrintdate(null);
    setClosedate(null);
    setPrinttitle(null);
    setDeposit(null);
    setDesc(null);
    setAddress(null);
    setExtra([]);
    setEnd(null);
    setCustvalue(null);
    setDepartvalue(null);
    setEmplvalue(null);
    setResovalue(null);
    setTasktitle(null);
    setSaving(false);
    setItemsList([]);
    setTotal(0);
    setCalcs(null);
    setMemitem(null);
    setRtypevalue(null);
    setTypefree(null);
    setType('');
    setPhotosimages([]);
    setUrls([]);
    setPhotosurls([]);
    setDiscount(0);
    setTaskvalue(null);
  };

  const onSubmit = async (bypassWarning = false) => {
    if (!start) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يجب تعديل التاريخ' : 'Date should be change',
      );
      return;
    }

    if (!bypassWarning) {
      const warnings: string[] = [];
      if (taskoptions?.photos && urls.length === 0) {
        warnings.push(
          isRTL
            ? 'يجب إرفاق صور للعقد والباقة'
            : 'Photos for Contract and Package should be attached',
        );
      }
      if (!deposit || deposit === 0) {
        warnings.push(
          isRTL ? 'لا تنسى إضافة مبلغ التأمين' : "Don't forget to add deposit",
        );
      }
      if (warnings.length > 0) {
        setWarningMessages(warnings);
        setWarningDialogOpen(true);
        return;
      }
    }

    if (taskoptions?.endrequire && !end) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يجب اضافة تاريخ الانتهاء' : 'End Date should be added',
      );
      return;
    }
    if (taskoptions?.customerrequire && !custvalue) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يرجى اضافة عميل' : 'Please add Customer',
      );
      return;
    }
    if (taskoptions?.resourserequire && !resovalue) {
      await messageAlert(
        setAlrt,
        isRTL
          ? `يرجى اضافة ${tempwords?.resourse}`
          : `Please add ${tempwords?.resourse}`,
      );
      return;
    }
    if (
      taskoptions?.items &&
      taskoptions?.itemsrequire &&
      (!itemsList || itemsList.length === 0)
    ) {
      await messageAlert(
        setAlrt,
        isRTL
          ? `يجب اضافة عنصر واحد على الأقل`
          : `You should add min one service`,
      );
      return;
    }

    setSaving(true);

    const items =
      !tempoptions?.itemrelations && !tempoptions?.invoiceitemrelations
        ? itemsList?.map((il: any) => {
            return {
              ...il,
              departmentId: departvalue?._id,
              departmentName: departvalue?.name,
              departmentNameAr: departvalue?.nameAr,
              departmentColor: departvalue?.color,
              employeeId: emplvalue?._id,
              employeeName: emplvalue?.name,
              employeeNameAr: emplvalue?.nameAr,
              employeeColor: emplvalue?.color,
              employeePhone: emplvalue?.phone,
              resourseId: resovalue?._id,
              resourseName: resovalue?.name,
              resourseNameAr: resovalue?.nameAr,
              resourseColor: resovalue?.color,
            };
          })
        : itemsList;

    let localphotos = [];
    if (photosimages) {
      const photosurl = await uploadMultiPhotoOnline(photosimages);
      if (photosurl && photosurl.length > 0) {
        const rphotos = photosurl.map((photo: any) =>
          photo.replace('http://', 'https://'),
        );
        localphotos = rphotos;
      }
    }

    const fphotos = [...photosurls, ...localphotos];
    const photos = JSON.stringify(fphotos);
    const variables: any = {
      _id: memitem && memitem._id ? memitem._id : undefined, // is it new or edit
      title: tasktitle ? tasktitle : tempwords?.task,
      start,
      end,
      total,
      discount,
      amount: discount ? total - discount : total,
      typefree: typefree?.id,
      type,
      items: items?.length > 0 ? JSON.stringify(items) : undefined,
      photos: fphotos && fphotos.length > 0 ? photos : null,
      customer,
      department,
      employee,
      resourse,
      retype,
      memId: isNew && memitem ? memitem?._id : undefined,
      periodCost: total,
      desc,
      printdate,
      closedate,
      printtitle,
      deposit,
      address,
      extra: extra ? JSON.stringify(extra) : null,
      parent: taskvalue?._id ? taskvalue?._id : undefined,
      smsmsg: sendSms && isNew ? smsmsg : null,
      smsqty: sendSms && isNew ? Math.ceil(smsmsg.length / 70) : 0,
    };
    const mutate = !memitem?._id ? addAction : editAction;
    apply(mutate, variables);
  };

  const apply = async (mutate: any, variables: any) => {
    try {
      await mutate({ variables });
      await successAlert(setAlrt, isRTL);
      setSaving(false);
      onCloseForm();
    } catch (error) {
      onError(error);
      console.log(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      reset();
      console.log(error);
    }
  };

  const onCloseForm = () => {
    resetAllForms();
    onClose();
    setSaving(false);
  };

  const onHandleSubmit = () => {
    onSubmit(false);
  };

  const handleWarningProceed = () => {
    setWarningDialogOpen(false);
    setWarningMessages([]);
    onSubmit(true);
  };

  const handleWarningCancel = () => {
    setWarningDialogOpen(false);
    setWarningMessages([]);
  };

  const day = weekdaysNNo?.[new Date(start).getDay()];

  const title = `${getPopupTitle('task', isNew)}  ${memitem?.title || ''}`;

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onCloseForm}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      onlyclose={!userroles?.operations?.add}
      print={handleReactPrint}
      maxWidth={'xl'}
      preventclose
      saving={saving}
      canceltitle={isRTL ? 'اغلاق' : 'close'}
    >
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <AutoFieldLocal
                  name="task"
                  title={tempwords?.task}
                  words={words}
                  options={tasks}
                  value={taskvalue}
                  setSelectValue={setTaskvalue}
                  register={register}
                  isRTL={isRTL}
                  width={400}
                  mb={0}
                ></AutoFieldLocal>
              </Grid>
              {taskoptions?.printdate && (
                <Grid item xs={3} style={{ marginTop: -20 }}>
                  <CalenderLocal
                    label={isRTL ? 'التاريخ' : 'Date'}
                    value={printdate}
                    onChange={(d: any) => setPrintdate(d)}
                    format="dd/MM/yyyy"
                    mb={0}
                    style={{
                      marginTop: 0,
                      width: 180,
                    }}
                  ></CalenderLocal>
                </Grid>
              )}
              <Grid item xs={3} style={{ marginTop: -20 }}>
                <CalenderLocal
                  label={words.start}
                  value={start}
                  onChange={(d: any) => {
                    if (taskoptions?.oneday) {
                      const start = d;
                      const end = d;
                      start.setHours(8, 0, 0, 0);
                      end.setHours(20, 0, 0, 0);
                      setStart(start);
                      setEnd(end);
                    } else {
                      setStart(d);
                    }
                  }}
                  format={
                    taskoptions?.time ? 'dd/MM/yyyy - hh:mm' : 'dd/MM/yyyy'
                  }
                  time={tempoptions?.time}
                  isRTL={isRTL}
                  mb={0}
                  style={{
                    marginTop: 0,
                    width: 180,
                  }}
                ></CalenderLocal>
              </Grid>
              <Grid item xs={3} style={{ marginTop: -20 }}>
                <CalenderLocal
                  value={end}
                  label={words.end}
                  onChange={(d: any) => {
                    if (d) {
                      if (taskoptions?.oneday) d.setHours(20, 0, 0, 0);
                      setEnd(d);
                    } else {
                      setEnd(null);
                    }
                  }}
                  isRTL={isRTL}
                  format={
                    taskoptions?.time ? 'dd/MM/yyyy - hh:mm' : 'dd/MM/yyyy'
                  }
                  time={tempoptions?.time}
                  style={{
                    marginTop: 0,
                    width: 180,
                  }}
                  mb={0}
                ></CalenderLocal>
              </Grid>
              {row?.isClosed && (
                <Grid
                  item
                  xs={3}
                  style={{ marginTop: -20, backgroundColor: '#ff000033' }}
                >
                  <CalenderLocal
                    value={closedate}
                    label={isRTL ? 'تاريخ الاغلاق' : 'Closed Date'}
                    onChange={(d: any) => {
                      if (d) {
                        setClosedate(d);
                      } else {
                        setClosedate(null);
                      }
                    }}
                    isRTL={isRTL}
                    format={
                      taskoptions?.time ? 'dd/MM/yyyy - hh:mm' : 'dd/MM/yyyy'
                    }
                    style={{
                      marginTop: 0,
                      width: 180,
                    }}
                    mb={0}
                  ></CalenderLocal>
                </Grid>
              )}
              <Grid item xs={3} style={{ marginTop: -20 }}>
                {taskoptions?.duration && (
                  <AutoFieldLocal
                    name="type"
                    title={words?.duration}
                    words={words}
                    options={tasktypes}
                    value={typefree}
                    setSelectValue={setTypefree}
                    register={register}
                    isRTL={isRTL}
                    fullWidth
                    nosort
                    mb={0}
                  ></AutoFieldLocal>
                )}
              </Grid>
              {taskoptions?.printtitle && (
                <Grid item xs={6}>
                  <TextFieldLocal
                    name="printtitle"
                    label={isRTL ? 'عنوان للطباعة' : 'Print Title'}
                    value={printtitle}
                    onChange={(e: any) => setPrinttitle(e.target.value)}
                    row={memitem}
                    fullWidth
                    mb={0}
                  />
                </Grid>
              )}
              <Grid item xs={6}>
                <TextFieldLocal
                  name="printtitle"
                  label={isRTL ? 'اسم العقد' : 'Title'}
                  value={tasktitle}
                  onChange={(e: any) => setTasktitle(e.target.value)}
                  row={memitem}
                  fullWidth
                  mb={0}
                />
              </Grid>

              {taskoptions?.customer && (
                <Grid item xs={6}>
                  <AutoFieldLocal
                    name="customer"
                    title={tempwords?.customer}
                    words={words}
                    options={customers}
                    value={custvalue}
                    setSelectValue={setCustvalue}
                    setSelectError={setCustError}
                    selectError={custError}
                    refernce={custRef}
                    register={register}
                    isRTL={isRTL}
                    fullWidth
                    showphone
                    openAdd={openCustomer}
                    disabled={name === 'customerId'}
                  ></AutoFieldLocal>
                </Grid>
              )}

              {tempoptions?.docrelations && (
                <>
                  {taskoptions?.employee && tempoptions?.employee && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="employee"
                        title={tempwords?.employee}
                        words={words}
                        options={employees.filter((emp: any) => !emp.disabled)}
                        disabled={isemployee || name === 'employeeId'}
                        value={emplvalue}
                        setSelectValue={setEmplvalue}
                        setSelectError={setEmplError}
                        selectError={emplError}
                        refernce={emplRef}
                        register={register}
                        openAdd={openEmployee}
                        isRTL={isRTL}
                        fullWidth
                        day={day}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                  {taskoptions?.department && tempoptions?.department && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="department"
                        title={tempwords?.department}
                        words={words}
                        options={departments.filter(
                          (d: any) => d.depType === 1,
                        )}
                        value={departvalue}
                        setSelectValue={setDepartvalue}
                        setSelectError={setDepartError}
                        selectError={departError}
                        refernce={departRef}
                        register={register}
                        openAdd={openDepartment}
                        isRTL={isRTL}
                        fullWidth
                        disabled={name === 'departmentId'}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                  {taskoptions?.resourse && tempoptions?.resourse && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="resourse"
                        title={tempwords?.resourse}
                        words={words}
                        options={resourses}
                        disabled={name === 'resourseId'}
                        value={resovalue}
                        setSelectValue={setResovalue}
                        setSelectError={setResoError}
                        selectError={resoError}
                        refernce={resoRef}
                        register={register}
                        openAdd={openResourse}
                        isRTL={isRTL}
                        fullWidth
                        day={day}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                </>
              )}
              {tempoptions?.retype && taskoptions?.retype && (
                <Grid item xs={6}>
                  <AutoFieldLocal
                    name="retype"
                    title={tempwords?.evretype}
                    words={words}
                    options={retypes.filter((dep: any) => dep.reType === 4)}
                    value={rtypevalue}
                    setSelectValue={setRtypevalue}
                    register={register}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {taskoptions?.address && (
                <Grid item xs={6}>
                  <TextFieldLocal
                    autoFocus={true}
                    name="address"
                    label={isRTL ? 'الموقع' : 'Address'}
                    value={address}
                    onChange={(e: any) => setAddress(e.target.value)}
                    row={memitem}
                    fullWidth
                    mb={0}
                  />
                </Grid>
              )}
              {taskoptions?.items && (
                <Grid item xs={12}>
                  <Box
                    style={{
                      backgroundColor: '#f0f8ff',
                      marginTop: 10,
                      borderRadius: 10,
                      height: 485,
                    }}
                  >
                    <Box display="flex">
                      <ServiceItemForm
                        services={_.concat(collectiveitems, services)}
                        products={products}
                        addItem={addItemToList}
                        words={words}
                        classes={classes}
                        user={user}
                        isRTL={isRTL}
                        setAlrt={setAlrt}
                        taskv={memitem}
                        itemrelations={
                          tempoptions?.invoiceitemrelations ||
                          tempoptions?.itemrelations
                        }
                      ></ServiceItemForm>
                    </Box>
                    <Box>
                      <ItemsContractTable
                        products={[
                          ...collectiveitems,
                          ...rentitems,
                          ...services,
                          ...products,
                        ]}
                        height={280}
                        rows={itemsList}
                        editItem={editItemInList}
                        removeItem={removeItemFromList}
                        isRTL={isRTL}
                        words={words}
                        user={user}
                        istask
                        itemrelations={
                          tempoptions?.invoiceitemrelations ||
                          tempoptions?.itemrelations
                        }
                      ></ItemsContractTable>
                      <Box
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexGrow: 1,
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          height: 45,
                        }}
                      >
                        {itemsList?.length > 0 && (
                          <Typography
                            style={{
                              fontWeight: 'bold',
                              fontSize: 16,
                              paddingLeft: 10,
                              paddingRight: 10,
                            }}
                          >
                            {words.total} :{' '}
                            {moneyFormat(discount ? total - discount : total)}
                          </Typography>
                        )}
                        <TextField
                          name="discount"
                          label={words.discount}
                          value={discount?.toString()}
                          onChange={(e: any) =>
                            setDiscount(Number(e.target.value))
                          }
                          variant="outlined"
                          style={{
                            width: 200,
                            marginLeft: 10,
                            marginRight: 10,
                          }}
                          margin="dense"
                          type="number"
                          onFocus={(e) => e.target.select()}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )}

              {taskoptions?.desc && (
                <Grid item xs={12}>
                  <TextFieldLocal
                    name="desc"
                    onChange={(e: any) => setDesc(e.target.value)}
                    value={desc}
                    label={words?.description}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    mb={0}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            item
            xs={4}
            style={{
              backgroundColor: fade(colors.grey[400], 0.1),
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            <Grid container spacing={1}>
              {!isNew && (
                <Grid item md={12}>
                  <PrintDownload
                    company={company}
                    printData={printData}
                    componentRef={componentRef}
                    handleReactPrint={handleReactPrint}
                    isRTL={isRTL}
                    template={template}
                    no={row?.docNo}
                    element="contract"
                    approvalStatus={memitem?.approvalStatus}
                  ></PrintDownload>
                </Grid>
              )}

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextFieldLocal
                      name="deposit"
                      label={isRTL ? 'مبلغ تأمين' : 'Insurance Payment'}
                      value={deposit}
                      onChange={onChangeDeposit}
                      type="number"
                      fullWidth
                      mb={0}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextFieldLocal
                      name="deposit"
                      label={isRTL ? 'طريقة الدفع' : 'Payment Type'}
                      value={type}
                      onChange={onChangeType}
                      fullWidth
                      mb={0}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {taskoptions?.extra && (
                <Grid item xs={12}>
                  <ExtraList
                    isRTL={isRTL}
                    list={extra}
                    setList={setExtra}
                  ></ExtraList>
                </Grid>
              )}
              {taskoptions?.photos && (
                <Grid item xs={12}>
                  <Box
                    style={{
                      height: 200,
                      margin: 5,
                    }}
                  >
                    <ImageView
                      images={urls}
                      removePhoto={removePhoto}
                      height={200}
                      small
                    ></ImageView>
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      flex: 1,
                      height: 40,
                      width: 200,
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 5,
                    }}
                  >
                    <UploadPhotos
                      setImages={addToPhotos}
                      isRTL={isRTL}
                    ></UploadPhotos>
                  </Box>
                </Grid>
              )}
              {isNew && (
                <>
                  <Grid item xs={12} style={{ marginTop: 30 }}>
                    <TextFieldLocal
                      required
                      name="body"
                      multiline
                      maxLength={210}
                      rows={4}
                      label={words.body}
                      value={smsmsg}
                      onChange={(e: any) => setSmsmsg(e.target.value)}
                      row={row}
                      fullWidth
                      mb={0}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sendSms}
                          onChange={(e) => setSendSms(e.target.checked)}
                          name="sendSms"
                          color="primary"
                        />
                      }
                      label={isRTL ? 'إرسال رسالة نصية' : 'Send SMS'}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
        <PopupCustomer
          newtext={newtext}
          open={openCust}
          onClose={onCloseCustomer}
          isNew={true}
          setNewValue={onNewCustChange}
          row={null}
          addAction={addCustomer}
          editAction={editCustomer}
        ></PopupCustomer>
        <PopupDeprtment
          newtext={newtext}
          open={openDep}
          onClose={onCloseDepartment}
          isNew={true}
          setNewValue={onNewDepartChange}
          row={null}
          addAction={addDepartment}
          editAction={editDepartment}
        ></PopupDeprtment>
        <PopupEmployee
          newtext={newtext}
          open={openEmp}
          onClose={onCloseEmploee}
          isNew={true}
          setNewValue={onNewEmplChange}
          row={null}
          addAction={addEmployee}
          editAction={editEmployee}
        ></PopupEmployee>
        <PopupResourses
          newtext={newtext}
          open={openRes}
          onClose={onCloseResourse}
          isNew={true}
          setNewValue={onNewResoChange}
          row={null}
          addAction={addResourse}
          editAction={editResourse}
        ></PopupResourses>

        <Dialog
          open={warningDialogOpen}
          onClose={handleWarningCancel}
          aria-labelledby="warning-dialog-title"
          aria-describedby="warning-dialog-description"
          maxWidth="md"
          style={{ direction: isRTL ? 'rtl' : 'ltr' }}
        >
          <DialogTitle id="warning-dialog-title">
            {isRTL ? 'تحذير' : 'Warning'}
          </DialogTitle>
          <DialogContent style={{ width: '600px' }}>
            <DialogContentText id="warning-dialog-description">
              {warningMessages.map((msg, index) => (
                <Box key={index} style={{ marginBottom: 8 }}>
                  • {msg}
                </Box>
              ))}
              <Box style={{ marginTop: 16, fontWeight: 'bold' }}>
                {isRTL
                  ? 'هل تريد المتابعة على أي حال؟'
                  : 'Do you want to proceed anyway?'}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleWarningCancel} color="primary">
              {isRTL ? 'رجوع للتعديل' : 'Back to Edit'}
            </Button>
            <Button
              onClick={handleWarningProceed}
              color="primary"
              autoFocus
              variant="contained"
            >
              {isRTL ? 'متابعة الحفظ' : 'Proceed with Save'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </PopupLayout>
  );
};

export default PopupTaskFree;
